// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getOrdersAnalyticsApi } from "../../Service/Api/OrdersAnalyticsApi"
import { getOrdersAnalyticsList,getErrors } from "../Reducer/OrdersAnalyticsReducer"
 
 

 

// Watchers
function* ordersAnalyticsSaga() {
	yield takeEvery("ordersAnalytics/getOrdersAnalytics", getOrderssAnalytics)
}

// Sagas
function* getOrderssAnalytics(action) {
	// console.log(action)
	try {
		const getOrderAnalytics = yield call(getOrdersAnalyticsApi, action.payload)
		// console.log(getOrdersAnalytics.status);
		if (getOrderAnalytics.request.status === 200) {
			yield put(getOrdersAnalyticsList(getOrderAnalytics))
			// console.log(getOrdersAnalytics.status);
		} else {
			yield put(getErrors(getOrderAnalytics))
		}
	} catch (error) {

		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(ordersAnalyticsSaga)])
}
